export default "__VITE_ASSET__BbT3qonN__"